import Vue from 'vue'
import urlParamsTransformer from '@/transformers/utils/urlParamsTransformer'
import requisitionTransformer from './../../transformers/purchase/requisition'

export default (options={}) => {
  const { searchQuery, ...pageParams } = options
  const params =  {
    ...urlParamsTransformer(options),
    folio: searchQuery
  }
  return Vue.$http.get('purchase/requisition_sinister/', {params})
    .then((response) => {
      const data = response.data
      const paginationInfo = {...data, results: null}
      const results = data.results

      const requisitions = requisitionTransformer.fetchCollection(results)

      return { requisitions, paginationInfo }
    })
  }


// WEBPACK FOOTER //
// ./src/services/purchase/fetchRequisition.js